/**
 * Values of a tag series for the statistical widgets. A missing or non-finite reading is a gap, not an observation:
 * reading it as 0 widens a gauge's range down to zero, drags an SPC centre line and its limits, and puts a
 * fabricated bar at zero in a histogram. A genuine zero is kept.
 */
import type { TimeseriesPoint } from "@/lib/widgets/types";

type Valued = Pick<TimeseriesPoint, "v">;

function observed(v: number | null | undefined): v is number {
  return v != null && Number.isFinite(v);
}

/** The series' observed values, in order. */
export function observedValues(series: readonly Valued[]): number[] {
  return series.map((p) => p.v).filter(observed);
}

/** The last `n` observations as individuals-chart points, numbered in order. Counts observations, not rows. */
export function lastObservations(series: readonly Valued[], n: number): { x: number; v: number }[] {
  return observedValues(series)
    .slice(-n)
    .map((v, i) => ({ x: i + 1, v }));
}
